import { getData, postData } from '~/utils/service';
import { CONTRACTS_PAGE_SIZE } from './constants';
import { ContractDetail, ContractListItem, ContractSummary, Scope } from './types';

const LIST_ROUTE = 'marketContractList';
const DETAIL_ROUTE = 'marketContractDetail';
const SUMMARY_ROUTE = 'marketContractSummary';
const SIGN_ROUTE = 'marketContractSign';
const TERMINATE_ROUTE = 'marketContractTerminate';
const WITHDRAW_TERMINATION_ROUTE = 'marketContractWithdrawTermination';

export const API_CALLS = {
  getList: async ({ input }: { input: Scope }): Promise<ContractListItem[]> => {
    const params: Record<string, string> = {
      page: String(input.context.page),
      pageSize: String(input.context.pageSize ?? CONTRACTS_PAGE_SIZE),
    };
    if (input.context.filterTab) params.status = input.context.filterTab;
    if (input.context.roleFilter) params.role = input.context.roleFilter;
    if (input.context.search) params.search = input.context.search;
    return await getData(LIST_ROUTE, { params });
  },
  getDetail: async ({ input }: { input: Scope }): Promise<ContractDetail> => {
    const id = input.context.selectedContractId;
    if (!id) throw new Error('Contract ID is required for getDetail');
    return await getData(DETAIL_ROUTE, {
      pathParams: { id: id.toString() },
    });
  },
  getSummary: async (): Promise<ContractSummary> => {
    return await getData(SUMMARY_ROUTE);
  },
  sign: async ({ input }: { input: Scope }) => {
    const id = input.context.selectedContractId;
    if (!id) throw new Error('Contract ID is required for sign');
    // [MCV-1829] The party signs by typing their name and agreeing to sign
    // electronically; the server rejects a missing name or consent with a 400.
    const event = input.event as {
      type: 'ON_SIGN';
      payload: { signerName: string; consentAccepted: boolean };
    };
    return await postData(SIGN_ROUTE, {
      pathParams: { id: id.toString() },
      data: {
        signerName: event.payload.signerName,
        consentAccepted: event.payload.consentAccepted,
      },
    });
  },
  requestTermination: async ({ input }: { input: Scope }) => {
    const id = input.context.selectedContractId;
    if (!id) throw new Error('Contract ID is required for requestTermination');
    const event = input.event as { type: 'ON_REQUEST_TERMINATION'; payload: { reason: string } };
    return await postData(TERMINATE_ROUTE, {
      pathParams: { id: id.toString() },
      data: { terminationReason: event.payload.reason },
    });
  },
  withdrawTermination: async ({ input }: { input: Scope }) => {
    const id = input.context.selectedContractId;
    if (!id) throw new Error('Contract ID is required for withdrawTermination');
    return await postData(WITHDRAW_TERMINATION_ROUTE, {
      pathParams: { id: id.toString() },
    });
  },
};
